<template>
  <div class="modal fade contact_form_modal" id="successModal" @click.self="$emit('close')">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body" style="margin:0; padding: 0">
          <div class="modal-content">
            <div class="contest-success-modal__header">
                <img src="/assets/site/images/contest/contest-success.png">
            </div>
            <div class="contest-success-modal__content">
              <h4 class="contest-success-modal__title">Отлично</h4>
              <p class="contest-success-modal__text">
                Ваш отзыв успешно добавлен и находится на модерации.<br>
                В ближайшее время он будет проверен и опубликован!
              </p>
              <div class="text-center">
                <button class="btn contest-success-modal__btn" @click.prevent="closeModal">
                  Закрыть
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      closeModal() {
        $('#successModal').modal('hide');
      },
      showSuccessModal() {
        $('#successModal').modal('show')
      }
    },
    mounted() {

    }
  }
</script>